import React from 'react';
import Helmet from 'react-helmet';

import siteData from '../services/siteData';
import Jumbotron from '../components/Jumbotron';

export default class NotFoundPage extends React.PureComponent {
  render() {
    return (
      <>
        <Helmet>
          <title>{`Not Found - ${siteData.title}`}</title>
        </Helmet>
        <Jumbotron
          variant="not-found"
          title="Not Found"
          text="We couldn't find the page you're looking for"
        />
      </>
    );
  }
}
